// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Auto-generated by Lowgile
import { VerifyExpenses as Llama__VerifyExpenses } from "../../Screen/Llama/VerifyExpenses.js";
import { ScanReceipt as Llama__ScanReceipt } from "../../Screen/Llama/ScanReceipt.js";
import { OpenReceiptButtonInclude as Llama__OpenReceiptButtonInclude } from "../../Screen/Llama/OpenReceiptButtonInclude.js";
import { MyExpenses as Llama__MyExpenses } from "../../Screen/Llama/MyExpenses.js";
import { MainLayoutSidebar as Llama__MainLayoutSidebar } from "../../Screen/Llama/MainLayoutSidebar.js";
import { MainLayoutHeader as Llama__MainLayoutHeader } from "../../Screen/Llama/MainLayoutHeader.js";
import { MainLayout as Llama__MainLayout } from "../../Screen/Llama/MainLayout.js";
import { LoaderDots as Llama__LoaderDots } from "../../Screen/Llama/LoaderDots.js";
import { InvoicePreparation as Llama__InvoicePreparation } from "../../Screen/Llama/InvoicePreparation.js";
import { Home as Llama__Home } from "../../Screen/Llama/Home.js";
import { ExpenseCardInclude as Llama__ExpenseCardInclude } from "../../Screen/Llama/ExpenseCardInclude.js";
import { AllExpenses as Llama__AllExpenses } from "../../Screen/Llama/AllExpenses.js";
import { Tasks as Common__Tasks } from "../../Screen/Common/Tasks.js";
import { SideMenu as Common__SideMenu } from "../../Screen/Common/SideMenu.js";
import { PlaceholderTask as Common__PlaceholderTask } from "../../Screen/Common/PlaceholderTask.js";
import { MainLayout as Common__MainLayout } from "../../Screen/Common/MainLayout.js";
import { Logo as Common__Logo } from "../../Screen/Common/Logo.js";
import { FancyLayout as Common__FancyLayout } from "../../Screen/Common/FancyLayout.js";

export const Declarations = [
    Llama__VerifyExpenses,
    Llama__ScanReceipt,
    Llama__OpenReceiptButtonInclude,
    Llama__MyExpenses,
    Llama__MainLayoutSidebar,
    Llama__MainLayoutHeader,
    Llama__MainLayout,
    Llama__LoaderDots,
    Llama__InvoicePreparation,
    Llama__Home,
    Llama__ExpenseCardInclude,
    Llama__AllExpenses,
    Common__Tasks,
    Common__SideMenu,
    Common__PlaceholderTask,
    Common__MainLayout,
    Common__Logo,
    Common__FancyLayout
];
